// actual polyfill input
import 'focus-visible';
/**
 * Utility that returns focus-visible selector according to current browser :focus-visible support
 * More info: https://github.com/WICG/focus-visible
 * Please note that we can't use .focus-visible selector as React components usually overwrite className each render
 */
export const focusVisible = () => '[data-focus-visible-added]';
//# sourceMappingURL=focusVisible.js.map